
import { Component, computed, input } from '@angular/core';

export type OaisStage =
  | 'ingest'
  | 'archival-storage'
  | 'data-management'
  | 'administration'
  | 'preservation-planning'
  | 'access';

@Component({
  selector: 'app-oais-status-indicator',
  standalone: true,
  imports: [],
  template: `
    <div class="oais">
      <span class="oais__label">Pipeline OAIS</span>
      <span class="oais__stage">{{ stageLabel() }}</span>
    </div>
  `,
  styles: [
    `
      .oais {
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        padding: 0.3rem 0.6rem;
        border-radius: 999px;
        border: 1px solid var(--md-sys-color-outline-variant);
        background: var(--md-sys-color-surface-container-low);
      }

      .oais__label {
        font-size: 0.72rem;
        color: var(--md-sys-color-on-surface-variant);
        text-transform: uppercase;
        letter-spacing: 0.03em;
      }

      .oais__stage {
        font-size: 0.8rem;
        font-weight: 600;
        color: var(--md-sys-color-on-surface);
      }
    `,
  ],
})
export class OaisStatusIndicatorComponent {
  readonly stage = input<OaisStage>('ingest');

  readonly stageLabel = computed(() => {
    const value = this.stage();
    if (value === 'ingest') return 'Ingest';
    if (value === 'archival-storage') return 'Archival Storage';
    if (value === 'data-management') return 'Data Management';
    if (value === 'administration') return 'Administration';
    if (value === 'preservation-planning') return 'Preservation Planning';
    return 'Access';
  });
}
